"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var base_service_1 = require("../base-service");
var alertminer_api_configuration_1 = require("../alertminer-api-configuration");
var operators_1 = require("rxjs/operators");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("../alertminer-api-configuration"));
var i2 = __importStar(require("@angular/common/http"));
var TrimAlternateOfferClientService = /** @class */ (function (_super) {
    __extends(TrimAlternateOfferClientService, _super);
    function TrimAlternateOfferClientService(config, http) {
        return _super.call(this, config, http) || this;
    }
    /**
     * @param params The `TrimAlternateOfferClientService.ByDealeridByBasetrimidByLevelDELETEParams` containing the following parameters:
     *
     * - `level`:
     *
     * - `dealerID`:
     *
     * - `baseTrimID`:
     */
    TrimAlternateOfferClientService.prototype.ByDealeridByBasetrimidByLevelDELETEResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('DELETE', this.rootUrl + ("/api/TrimAlternateOffer/" + params.dealerID + "/" + params.baseTrimID + "/" + params.level), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `TrimAlternateOfferClientService.ByDealeridByBasetrimidByLevelDELETEParams` containing the following parameters:
     *
     * - `level`:
     *
     * - `dealerID`:
     *
     * - `baseTrimID`:
     */
    TrimAlternateOfferClientService.prototype.ByDealeridByBasetrimidByLevelDELETE = function (params) {
        return this.ByDealeridByBasetrimidByLevelDELETEResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param data undefined
     */
    TrimAlternateOfferClientService.prototype.PUTResponse = function (data) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = data;
        var req = new http_1.HttpRequest('PUT', this.rootUrl + "/api/TrimAlternateOffer", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param data undefined
     */
    TrimAlternateOfferClientService.prototype.PUT = function (data) {
        return this.PUTResponse(data).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param data undefined
     * @return Success
     */
    TrimAlternateOfferClientService.prototype.POSTResponse = function (data) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = data;
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/TrimAlternateOffer", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param data undefined
     * @return Success
     */
    TrimAlternateOfferClientService.prototype.POST = function (data) {
        return this.POSTResponse(data).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `TrimAlternateOfferClientService.BulkDeletePOSTParams` containing the following parameters:
     *
     * - `trimIDs`:
     *
     * - `level`:
     *
     * - `dealerID`:
     */
    TrimAlternateOfferClientService.prototype.BulkDeletePOSTResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = params.trimIDs;
        if (params.level != null)
            __params = __params.set('level', params.level.toString());
        if (params.dealerID != null)
            __params = __params.set('dealerID', params.dealerID.toString());
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/TrimAlternateOffer/BulkDelete", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `TrimAlternateOfferClientService.BulkDeletePOSTParams` containing the following parameters:
     *
     * - `trimIDs`:
     *
     * - `level`:
     *
     * - `dealerID`:
     */
    TrimAlternateOfferClientService.prototype.BulkDeletePOST = function (params) {
        return this.BulkDeletePOSTResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param params The `TrimAlternateOfferClientService.BulkRemoveMappingsPOSTParams` containing the following parameters:
     *
     * - `trimIDs`:
     *
     * - `level`:
     *
     * - `dealerID`:
     */
    TrimAlternateOfferClientService.prototype.BulkRemoveMappingsPOSTResponse = function (params) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = params.trimIDs;
        if (params.level != null)
            __params = __params.set('level', params.level.toString());
        if (params.dealerID != null)
            __params = __params.set('dealerID', params.dealerID.toString());
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/TrimAlternateOffer/BulkRemoveMappings", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param params The `TrimAlternateOfferClientService.BulkRemoveMappingsPOSTParams` containing the following parameters:
     *
     * - `trimIDs`:
     *
     * - `level`:
     *
     * - `dealerID`:
     */
    TrimAlternateOfferClientService.prototype.BulkRemoveMappingsPOST = function (params) {
        return this.BulkRemoveMappingsPOSTResponse(params).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    TrimAlternateOfferClientService.ByDealeridByBasetrimidByLevelDELETEPath = '/api/TrimAlternateOffer/{dealerID}/{baseTrimID}/{level}';
    TrimAlternateOfferClientService.PUTPath = '/api/TrimAlternateOffer';
    TrimAlternateOfferClientService.POSTPath = '/api/TrimAlternateOffer';
    TrimAlternateOfferClientService.BulkDeletePOSTPath = '/api/TrimAlternateOffer/BulkDelete';
    TrimAlternateOfferClientService.BulkRemoveMappingsPOSTPath = '/api/TrimAlternateOffer/BulkRemoveMappings';
    TrimAlternateOfferClientService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TrimAlternateOfferClientService_Factory() { return new TrimAlternateOfferClientService(i0.ɵɵinject(i1.AlertminerApiConfiguration), i0.ɵɵinject(i2.HttpClient)); }, token: TrimAlternateOfferClientService, providedIn: "root" });
    return TrimAlternateOfferClientService;
}(base_service_1.BaseService));
exports.TrimAlternateOfferClientService = TrimAlternateOfferClientService;
